import { Resources } from 'constants/resources';

import { useGetList } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { CommissionStatus } from 'types/embedded/commission';

import { useCommissionsFilterFields } from './useCommissionsFilterFields';

const EMPTY_STATUSES: CommissionStatus[] = [];

export const useCommissionsListFilterFields = () => {
  const { data: commissionStatuses } = useGetList<CommissionStatus>(Resources.CommissionStatuses);
  const { getValues, watch } = useFormContext();
  const merchantWatched = watch('merchant');

  return useCommissionsFilterFields({
    defaultStatus: getValues('status'),
    statusOptions: commissionStatuses ?? EMPTY_STATUSES,
    merchantWatched,
  });
};
